"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldValidationWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var portal_core_1 = require("@ferry/portal-core");
var RenderUtils_1 = require("./utils/RenderUtils");
var FieldValidationWidget = /** @class */ (function (_super) {
    __extends(FieldValidationWidget, _super);
    function FieldValidationWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showErrorMessage: true
        };
        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }
    FieldValidationWidget.prototype.render = function () {
        var bottomText = (0, RenderUtils_1.renderHtml)(this.getSetting("bottomText", "Please try again."), this.props.interaction);
        if (this.state.showErrorMessage) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "page-validation journey-validation-summary", role: "alert", children: [(0, jsx_runtime_1.jsx)("div", { className: "page-validation-alert", children: (0, jsx_runtime_1.jsx)("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/alert-red.svg") }) }), (0, jsx_runtime_1.jsxs)("div", { className: "page-validation-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-top", children: this.getSetting("topText") }), (0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-bottom", children: bottomText })] }), (0, jsx_runtime_1.jsx)("div", { className: "page-validation-close", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn page-validation-close-button", "aria-label": "close alert", onClick: this.handleClose }) })] }));
        }
        else {
            return null;
        }
    };
    FieldValidationWidget.prototype.handleClose = function () {
        this.setState({
            showErrorMessage: false
        });
    };
    return FieldValidationWidget;
}(plugin_journey_1.WidgetBase));
exports.FieldValidationWidget = FieldValidationWidget;
//# sourceMappingURL=FieldValidationWidget.js.map